<template>
  <div class="avi-dialogInspectionForm">
    <InspectionDocumentEditor :inspection="inspection" />
  </div>
</template>

<script>
import InspectionDocumentEditor from "@/components/ri3/documents/InspectionDocumentEditor"

export default {
  name: "InspectionDocumentEditorView",
  components: { InspectionDocumentEditor },
  props: {
    inDialog: {
      type: Boolean,
      default: false
    },
    inDialogParams: {
      type: Object,
      required: true
    }
  },
  computed: {
    inspection() {
      return this.inDialogParams.inspection
    }
  }
}
</script>
<style scoped>
.avi-dialogInspectionForm {
  min-height: 65vh;
}
</style>
